export class DeformSlotData {
    constructor() {
        this.deformSlotDisplayList = [];
    }
}
